import { bootstrapAnalyticsClient } from '@bootstrap/bootstrap/analytics'
import {
  bootstrapLocationClient,
  bootstrapLocationSSR,
} from '@bootstrap/bootstrap/location'
import { bootstrapToasts } from '@bootstrap/bootstrap/toasts'
import type { BootstrapOptions } from '@bootstrap/types'
import {
  bootstrapAuthClient,
  bootstrapAuthSSR,
} from '@shared/bootstrap/bootstraps/auth'
import { bootstrapCartSSR } from '@shared/bootstrap/bootstraps/cart'
import { bootstrapDeviceSSR } from '@shared/bootstrap/bootstraps/device'
import { bootstrapGlobalActionsClient } from '@shared/bootstrap/bootstraps/global-actions'
import {
  bootstrapWishlistClient,
  bootstrapWishlistSSR,
} from '@shared/bootstrap/bootstraps/wishlist'
import type { APIContext } from 'astro'

export const bootstrapSSR = async (context: APIContext) => {
  const token = context.locals.session?.token ?? null

  // Without Auth
  await Promise.all([
    bootstrapDeviceSSR(
      context.locals.deviceDetection.isMobile ? 'mobile' : 'desktop'
    ),
    bootstrapLocationSSR(context.url),
    bootstrapToasts(),
    bootstrapAuthSSR(token),
  ])

  // With Customer
  await Promise.all([bootstrapCartSSR(context.cookies), bootstrapWishlistSSR()])
}

export const bootstrap = async ({ analytics = {} }: BootstrapOptions = {}) => {
  await Promise.all([
    bootstrapLocationClient(),
    bootstrapGlobalActionsClient(),
    bootstrapWishlistClient(),
    bootstrapAnalyticsClient(analytics),
  ])

  // With Analytics, as it might trigger events on load
  await Promise.all([bootstrapAuthClient()])
}
